import React, { useState } from 'react'
import { Blacked, ModalContent, ModalHeader, ModalTitle, ModalWrapper } from '../styles';
import { Icon } from 'CRM/organism/Main/styles';
import { FaChevronLeft } from 'react-icons/fa6';
import { Select, message } from 'antd'
import API from 'utils/api';
import { useToken } from 'app/hooks';
import {useIsMobile} from "../IsMobile";

export const TotalDistribution = ({ selectTable, setSelectTable, setIsDistribution, mutate, resList }) => {
  const IsMobile = useIsMobile();
  const { data: token } = useToken();
  const [responsibilityId, setResponsibilityId] = useState('');

  const clickSubmit = () => {
    if(responsibilityId === '') {
      message.error('담당자를 선택하지 않았습니다.')
      return
    }

    const shouldEdit = window.confirm(`선택한 ${selectTable?.length}명을 담당자 "${resList?.find(it => it.id == responsibilityId)?.name}"(으)로 일괄배정하시겠습니까?`);
    if(shouldEdit) {
      API.put('/users/distribution', token + '', {
        datas: {
          ids: selectTable,
          responsibilityId: responsibilityId
        }
      })
      .then((res: any) => {
        if (res.result.success) {
          message.success('배정되었습니다');
          mutate();
          setIsDistribution(false);
          setSelectTable([]);
        } else {
          message.error(res.result.message || '배정에 실패했습니다')
        }
      })
      .catch((err: any) => {})
    }
  }

  return (
    <>
      <Blacked onClick={() => setIsDistribution(false)} />

      <ModalWrapper IsMobile={IsMobile} style={IsMobile ? {} : {width: '400px'}}>
        <ModalHeader>
          <Icon onClick={() => setIsDistribution(false)}><FaChevronLeft /></Icon>
          <ModalTitle>DB배분</ModalTitle>
          <div onClick={clickSubmit} style={{cursor: 'pointer', fontWeight: 'bold', color: '#437EFF'}}>저장</div>
        </ModalHeader>
        <ModalContent style={{padding: 20}}>
          <p style={{marginBottom: 12}}>선택한 {selectTable?.length}명을 일괄배정합니다.</p>
          <Select
            value={responsibilityId}
            onChange={(e) => setResponsibilityId(e)}
            style={{fontFamily: 'Pretendard', width: '100%'}}
            placeholder="담당자 선택"
          >
            {resList?.map(it => (
              <option key={it.id} value={it.id} style={{fontFamily: 'Pretendard'}}>{it.name}</option>
            ))}
          </Select>
        </ModalContent>
      </ModalWrapper>
    </>
  )
}

export default React.memo(TotalDistribution);
